import type {TimeZone} from '@hconnect/common/types'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE, PLANT_STATUS_DEFAULT_TIME_RANGE} from '../consts'
import {parseTimeRangeParamToDateRange, getPlantStatusQuickSelectionItems} from '../utils'

import {usePlantStatusPageParams} from './usePlantStatusPageParams'

type UseDateRangeParams = {
  timezone: TimeZone
}

export const usePlantStatusDateRange = ({timezone}: UseDateRangeParams) => {
  const {timeRangeParam} = usePlantStatusPageParams()
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const selectionItems = getPlantStatusQuickSelectionItems(t, timezone)

  return useMemo(
    () =>
      parseTimeRangeParamToDateRange({
        timeRange: timeRangeParam,
        timezone,
        selectionItems,
        defaultSelectionId: PLANT_STATUS_DEFAULT_TIME_RANGE
      }),
    [timeRangeParam, timezone, selectionItems]
  )
}
